module.exports = __webpack_public_path__ + "assets/img/FK8.db71f892.png";